<template>
  <v-container fill-height>
    <v-layout column justify-center align-center>
      <span class="home-title mb-5">
        Under construction.
      </span>
      <span class="home-subtitle">
        Please check back later!
      </span>
    </v-layout>
  </v-container>
</template>

<script>
import colors from '@/utils/colors';

export default {
  data: () => ({
    colors,
  }),
};
</script>

<style lang="scss" scoped>
.home-title {
  font-size: 2rem;
}

.home-subtitle {
  font-size: 1rem;
  letter-spacing: 0.05rem;
}
</style>
